import { render, staticRenderFns } from "./plan_main.vue?vue&type=template&id=06d83548&scoped=true&"
import script from "./plan_main.vue?vue&type=script&lang=js&"
export * from "./plan_main.vue?vue&type=script&lang=js&"
import style0 from "./plan_main.vue?vue&type=style&index=0&id=06d83548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d83548",
  null
  
)

export default component.exports